import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1d126e01"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = { class: "phone" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "red-bar" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/images/peppers.svg" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "mobile-wrapper"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-red-bar" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/images/peppers.svg" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.store.loaded && !_ctx.store.showMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("a", {
              href: 'tel:' + _ctx.store.phone.replaceAll(' ', '')
            }, _toDisplayString(_ctx.store.phone), 9, _hoisted_3)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              to: "/about",
              class: _normalizeClass(['text-left', {'hide-text': _ctx.$route.name === 'about'}]),
              textContent: '<-- Кто мы?'
            }, null, 8, ["class"]),
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              class: _normalizeClass(['text-right', 'align-right', {'hide-text': _ctx.$route.name !== 'about'}]),
              textContent: 'Всё там -->'
            }, null, 2)
          ]),
          _createElementVNode("div", null, [
            _hoisted_4,
            _createVNode(_component_router_link, {
              to: "/",
              class: "logo"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.store.loaded && _ctx.store.showMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_router_link, {
            to: "/",
            class: "mobile-logo"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}